import { createFileRoute } from '@tanstack/react-router';

import { InvitationPage } from '@/pages/invitation/invitation-page';

export const Route = createFileRoute('/invites/$token')({
  component: InvitationPage,
});
